import { z } from 'zod/v4';
import { heatMapTimeSeriesDataSchema } from './heatmap';
import { timeSeriesDataSchema } from './time-series';

/**
 * Zod schema for DistributionDataResponse.
 *
 * DistributionData is a discriminated union that can be either:
 * - TimeSeriesDistributionData (extends TimeSeriesData with distributionKind)
 * - HeatMapDistributionData (extends HeatMapTimeSeriesData with distributionKind)
 */

const timeSeriesDistributionDataSchema = timeSeriesDataSchema.extend({
  distributionKind: z.literal('TimeSeries'),
});

const heatMapDistributionDataSchema = heatMapTimeSeriesDataSchema.extend({
  distributionKind: z.literal('HeatMap'),
});

const distributionDataSchema = z.union([timeSeriesDistributionDataSchema, heatMapDistributionDataSchema]);

export const distributionDataResponseSchema = z.object({
  type: z.literal('Distribution'),
  data: distributionDataSchema,
});

export type DistributionDataResponseSchema = z.infer<typeof distributionDataResponseSchema>;
